import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const api = new AxiosInterceptor();
const prefix = "/memberships";

export default {
  find(id) {
    return api.get(prefix + "/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get(prefix + "?" + qstr);
  },
  delete(id) {
    return api.delete(prefix + "/" + id);
  },
  update(id, inputs) {
    return api.put(prefix + "/" + id, inputs);
  },
  getVoucherUsages(id) {
    return api.get(prefix + "/" + id + "/voucher-usages");
  },
  cancel(id) {
    return api.put(prefix + "/" + id + "/cancel");
  },
};